const spaceIds = {
  local: 2448969879444896,
  dev: 2448969879444896,
  test: 2452681552360416,
  pre: 2453470978758048,
  prod: 2453470978758048,
}

const getSpaceId = (env) => {
  return spaceIds[env]
}

const categoryFilters = {
  // 后期版本升级，softwareVersion可能会有变化
  0.12: [{
    platformCode: 'NOVA_DESIGN',
    softwareCode: 'AppDeco',
    softwareVersion: '0.12',
    versionComparisonType: 'LTE'
  },
  {
    platformCode: 'GENERAL',
    softwareCode: 'sketchup',
    softwareVersion: '2017',
    versionComparisonType: 'LTE'
  }],
  0.13: [{
    platformCode: 'NOVA_DESIGN',
    softwareCode: 'AppDeco',
    softwareVersion: '0.13',
    versionComparisonType: 'LTE'
  },
  {
    platformCode: 'GENERAL',
    softwareCode: 'sketchup',
    softwareVersion: '2017',
    versionComparisonType: 'LTE'
  }]
}
const getCategoryFilters = (softwareVersion) => {
  return categoryFilters[softwareVersion]
}

export default { getSpaceId, getCategoryFilters }
